<template>
  <v-select
    v-model="input"
    :rules="requiredRule"
    :items="values"
    :label="customField.label + (required ? ' *' : '')"
    :hint="customField.hint"
    :disabled="disabled"
    :loading="loading"
    :placeholder="customField.placeholder"
    :clearable="!required"
    persistent-hint
    @change="input = $event"
    outlined
  >
    <template #selection="{ item }">
      <custom-field-value-chip :value="item" />
    </template>
    <template #item="{ item }">
      <v-list-item-content>
        <v-list-item-title>
          <div style="display: flex">
            <v-sheet rounded="pill" :color="`${item.color} lighten-3`" class="mr-1 mb-n1" height="18" width="18" />
            {{ item.value }}
          </div>
        </v-list-item-title>
        <v-list-item-subtitle>{{ item.description }} </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<style></style>

<script lang="ts">
import { Component } from "vue-property-decorator";
import CustomFieldText from "./CustomFieldText.vue";
import CustomFieldValueChip from "./CustomFieldValueChip.vue";
import Debug from "../utility/Debug.vue";

@Component({
  components: { CustomFieldValueChip, Debug }
})
export default class CustomFieldSingleSelect extends CustomFieldText {
  get values() {
    return this.customField.configuration?.values ?? [];
  }

  get input(): string {
    if (typeof this.value === "string") {
      return this.value;
    }

    return this.value[0];
  }

  set input(v: string) {
    this.$emit("input", v);
  }
}
</script>
